import { videoRoomsApi } from '../services/videoRoomsApi';

/** Daily credentials stay on the Hostinger PHP server. */
export const DAILY_CONFIG = { apiUrl: 'https://api.daily.co/v1' };

export const DEFAULT_ROOM_CONFIG = {
  privacy: 'private' as const,
  properties: {
    enable_chat: false,
    enable_screenshare: false,
    enable_recording: 'cloud' as const,
    start_video_off: false,
    start_audio_off: false,
    max_participants: 2,
  },
};

export function createDailyRoom(sessionId: string, nutritionistId: string, patientId: string) {
  return videoRoomsApi.createDailyRoom(sessionId, nutritionistId, patientId);
}

export async function deleteDailyRoom(roomName: string): Promise<void> {
  try {
    await videoRoomsApi.deleteDailyRoom(roomName);
  } catch (error) {
    console.error('Erro ao deletar sala Daily:', error);
  }
}

export default DAILY_CONFIG;
